import React, { useMemo } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';

function VersionHistoryTab({ product, allProducts }) {
  const versionHistoryData = useMemo(() => {
    // If the full list of versions (`allProducts`) is available, use it.
    console.log('version history tab', allProducts);
    if (allProducts && allProducts.length > 0) {
      return allProducts;
    }
    // If `allProducts` is not available, but we have the current `product`,
    // show at least that single version in the history.
    if (product) {
      return [product];
    }
    // Otherwise, there's nothing to show.
    return [];
  }, [allProducts, product]);

  if (!product) return null;

  return (
    <ArgonBox p={3}>
      {versionHistoryData.length > 0 ? (
        <TableContainer component={Paper}>
          <Table aria-label="version history table">
            <TableHead sx={{ display: 'contents' }}>
              <TableRow>
                <TableCell>
                  <ArgonTypography variant="subtitle2" color="secondary">
                    Created By
                  </ArgonTypography>
                </TableCell>
                <TableCell>
                  <ArgonTypography variant="subtitle2" color="secondary">
                    Created Date
                  </ArgonTypography>
                </TableCell>
                <TableCell>
                  <ArgonTypography variant="subtitle2" color="secondary">
                    Product Version
                  </ArgonTypography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {versionHistoryData
                .sort((a, b) => new Date(b.created_date) - new Date(a.created_date)) // Sort by date descending
                .map((version, index) => (
                  <TableRow key={version._id || index}>
                    <TableCell>
                      <ArgonTypography variant="body2">{version.user?.email || 'N/A'}</ArgonTypography>
                    </TableCell>
                    <TableCell>
                      <ArgonTypography variant="body2">
                        {new Date(version.created_date).toLocaleString()}
                      </ArgonTypography>
                    </TableCell>
                    <TableCell>
                      <ArgonTypography variant="body2">{version.product_version || 'N/A'}</ArgonTypography>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <ArgonTypography variant="body2" color="textSecondary">
          No version history available for this product.
        </ArgonTypography>
      )}
    </ArgonBox>
  );
}

export default VersionHistoryTab;
